import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Paper,
  Grid,
  TextField,
  Button,
  Snackbar,
  Card,
  CardContent,
  Box,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  Menu,
  MenuItem
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import axios from "axios";
import api from "../api";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import DescriptionIcon from "@material-ui/icons/Description";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import PersonIcon from "@material-ui/icons/Person";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    paddingBottom: theme.spacing(8)
  },
  appBar: {
    backgroundColor: "#1e40af",
    boxShadow: "none",
    borderBottom: "1px solid #e2e8f0"
  },
  title: {
    flexGrow: 1,
    fontWeight: 700,
    fontSize: "1.1rem",
    letterSpacing: 0.2,
    color: "#fff"
  },
  container: {
    marginTop: theme.spacing(1),
    maxWidth: "100%",
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
      maxWidth: "800px",
      margin: "0 auto"
    }
  },
  paper: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    borderRadius: theme.spacing(1.5),
    boxShadow: "0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06)",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2.5)
    }
  },
  sectionTitle: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#1e293b",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    borderBottom: "2px solid #e2e8f0",
    "& svg": {
      marginRight: theme.spacing(0.75),
      color: "#3b82f6",
      fontSize: "1.2rem"
    }
  },
  photoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
      gap: theme.spacing(1.5)
    }
  },
  photoCard: {
    borderRadius: theme.spacing(1.5),
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      transform: "translateY(-2px)"
    },
    "& img": {
      width: "100%",
      height: "120px",
      objectFit: "cover",
      [theme.breakpoints.up('sm')]: {
        height: "140px"
      }
    }
  },
  signatureContainer: {
    border: "2px dashed #cbd5e1",
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(2),
    backgroundColor: "#f8fafc",
    textAlign: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#94a3b8",
      backgroundColor: "#f1f5f9"
    }
  },
  canvas: {
    border: "1px solid #ccc",
    borderRadius: theme.spacing(1),
    width: "100%",
    height: 200,
    backgroundColor: "#fff",
    cursor: "crosshair",
    touchAction: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none"
  },
  actionBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    borderTop: "1px solid #e2e8f0",
    padding: theme.spacing(1.5),
    boxShadow: "0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -1px rgba(0,0,0,0.06)",
    backdropFilter: "blur(8px)",
    zIndex: 1000
  },
  cameraDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "90vw",
      maxHeight: "90vh"
    }
  },
  cameraContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "500px",
    margin: "0 auto"
  },
  cameraPreview: {
    width: "100%",
    height: "auto",
    borderRadius: theme.spacing(1)
  },
  cameraControls: {
    position: "absolute",
    bottom: theme.spacing(2),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: theme.spacing(2)
  },
  photoSection: {
    marginBottom: theme.spacing(2)
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1.5)
  },
  photoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1.5)
  },
  photoCard: {
    position: "relative",
    borderRadius: theme.spacing(1),
    overflow: "hidden",
    border: "1px solid #e0e0e0",
    "& img": {
      width: "100%",
      height: "100px",
      objectFit: "cover"
    }
  },
  deleteButton: {
    position: "absolute",
    top: 4,
    right: 4,
    backgroundColor: "rgba(0,0,0,0.5)",
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.7)"
    }
  },
  addMoreButton: {
    width: "100%",
    height: "120px",
    border: "2px dashed #cbd5e1",
    borderRadius: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafc",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f1f5f9",
      borderColor: "#94a3b8",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    },
    [theme.breakpoints.up('sm')]: {
      height: "140px"
    }
  },
  addMoreIcon: {
    fontSize: "1.75rem",
    color: "#64748b",
    marginBottom: theme.spacing(0.5)
  },
  addMoreText: {
    color: "#64748b",
    fontSize: "0.875rem",
    fontWeight: 500
  },
  damageSection: {
    marginBottom: theme.spacing(1.5)
  },
  carImageContainer: {
    position: "relative",
    display: "inline-block",
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    borderRadius: theme.spacing(1.5),
    overflow: "hidden",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
    [theme.breakpoints.up('sm')]: {
      maxWidth: "600px"
    }
  },
  carImage: {
    width: "100%",
    height: "auto",
    borderRadius: theme.spacing(1.5),
    cursor: "crosshair",
    transition: "transform 0.2s ease",
  },
  damageMarker: {
    position: "absolute",
    width: "24px",
    height: "24px",
    backgroundColor: "#ef4444",
    borderRadius: "50%",
    border: "3px solid white",
    cursor: "pointer",
    transform: "translate(-50%, -50%)",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.3), 0 2px 4px -1px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translate(-50%, -50%) scale(1.2)",
      backgroundColor: "#dc2626",
      boxShadow: "0 6px 8px -1px rgba(0,0,0,0.4), 0 4px 6px -1px rgba(0,0,0,0.3)"
    }
  },
  damageMarkerNumber: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    fontSize: "12px",
    fontWeight: "bold",
    pointerEvents: "none"
  },
  damageList: {
    marginTop: theme.spacing(1.5)
  },
  damageItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5),
    border: "1px solid #e2e8f0",
    borderRadius: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    backgroundColor: "#f8fafc",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f1f5f9",
      borderColor: "#cbd5e1",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
    }
  },
  damageInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75)
  },
  damageNumber: {
    width: "24px",
    height: "24px",
    backgroundColor: "#f44336",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "12px",
    fontWeight: "bold"
  }
}));

const CarDamageMarker = ({ damages, onAddDamage, onRemoveDamage, onEditDamage, vehicleType }) => {
  const classes = useStyles();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const imageRef = useRef(null);

  const handleImageLoad = () => {
    if (imageRef.current) {
      const { naturalWidth, naturalHeight } = imageRef.current;
      setImageDimensions({ width: naturalWidth, height: naturalHeight });
      setImageLoaded(true);
    }
  };

  const handleImageClick = (event) => {
    if (!imageLoaded) return;
    
    const rect = imageRef.current.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    
    const newDamage = {
      id: Date.now(),
      x: x,
      y: y,
      description: "",
      severity: "minor"
    };
    
    onAddDamage(newDamage);
  };

  const damageTypes = [
    { value: "scratch", label: "Rayón" },
    { value: "dent", label: "Abolladura" },
    { value: "crack", label: "Grieta" },
    { value: "chip", label: "Chip" },
    { value: "rust", label: "Óxido" },
    { value: "other", label: "Otro" }
  ];

  const severityTypes = [
    { value: "minor", label: "Menor" },
    { value: "moderate", label: "Moderado" },
    { value: "major", label: "Mayor" }
  ];

  return (
    <div className={classes.damageSection}>
      <Typography className={classes.sectionTitle}>
        <EditIcon /> Marcado de Daños
      </Typography>
      
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Haz clic en la imagen del vehículo para marcar los daños encontrados.
      </Typography>
      
      <div className={classes.carImageContainer}>
        <img
          ref={imageRef}
          src={`https://efleet.autocorp.com.ar/autocorp-api/public/img/booking/${(vehicleType) || 'SUV'}.JPG`}
          alt={`Vehículo ${(vehicleType && vehicleType.name) || 'SUV'}`}
          className={classes.carImage}
          onClick={handleImageClick}
          onLoad={handleImageLoad}
        />
        
        {damages.map((damage, index) => (
          <div
            key={damage.id}
            className={classes.damageMarker}
            style={{
              left: `${damage.x}%`,
              top: `${damage.y}%`
            }}
            onClick={(e) => {
              e.stopPropagation();
              onEditDamage(damage);
            }}
            title="Haz clic para editar este daño"
          >
            <div className={classes.damageMarkerNumber}>
              {index + 1}
            </div>
          </div>
        ))}
      </div>
      
      {damages.length > 0 && (
        <div className={classes.damageList}>
          <Typography variant="h6" gutterBottom>
            Daños Marcados ({damages.length})
          </Typography>
          {damages.map((damage, index) => (
            <div key={damage.id} className={classes.damageItem} onClick={() => onEditDamage(damage)} style={{ cursor: 'pointer' }}>
              <div className={classes.damageInfo}>
                <div className={classes.damageNumber}>
                  {index + 1}
                </div>
                <div>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    {damage.description || `Daño ${index + 1}`}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Tipo: {(damageTypes.find(t => t.value === damage.type) || {}).label || 'No especificado'} | 
                    Severidad: {(severityTypes.find(s => s.value === damage.severity) || {}).label || 'Menor'}
                  </Typography>
                </div>
              </div>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveDamage(damage.id);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const DamageEditDialog = ({ open, damage, onClose, onSave, damageTypes, severityTypes }) => {
  const [formData, setFormData] = useState({
    description: "",
    type: "",
    severity: "minor"
  });

  useEffect(() => {
    if (damage) {
      setFormData({
        description: damage.description || "",
        type: damage.type || "",
        severity: damage.severity || "minor"
      });
    }
  }, [damage]);

  const handleSave = () => {
    onSave({ ...damage, ...formData });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar Daño</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descripción del daño"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Tipo de daño"
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              variant="outlined"
            >
              {damageTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Severidad"
              value={formData.severity}
              onChange={(e) => setFormData({ ...formData, severity: e.target.value })}
              variant="outlined"
            >
              {severityTypes.map((severity) => (
                <MenuItem key={severity.value} value={severity.value}>
                  {severity.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CameraDialog = ({ open, onClose, onCapture, currentSection }) => {
  const classes = useStyles();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      startCamera();
    } else {
      stopCamera();
    }
  }, [open]);

  const startCamera = async () => {
    try {
      // Check if we're on HTTPS (required for camera access)
      if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
        throw new Error('HTTPS required');
      }

      // Check if getUserMedia is supported
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('getUserMedia not supported');
      }

      // Try different camera configurations
      let mediaStream;
      const constraints = [
        { video: { facingMode: 'environment' } }, // Back camera
        { video: { facingMode: 'user' } },        // Front camera
        { video: true }                            // Any camera
      ];

      for (const constraint of constraints) {
        try {
          mediaStream = await navigator.mediaDevices.getUserMedia(constraint);
          break;
        } catch (err) {
          console.log('Failed with constraint:', constraint, err);
          continue;
        }
      }

      if (!mediaStream) {
        throw new Error('No camera available');
      }

      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
      setError(null);
    } catch (err) {
      console.error('Camera error:', err);
      
      let errorMessage = 'No se pudo acceder a la cámara';
      
      if (err.name === 'NotAllowedError') {
        errorMessage = 'Permisos de cámara denegados. Por favor, permite el acceso a la cámara en la configuración del navegador.';
      } else if (err.name === 'NotFoundError') {
        errorMessage = 'No se encontró ninguna cámara en el dispositivo.';
      } else if (err.name === 'NotSupportedError') {
        errorMessage = 'El navegador no soporta acceso a la cámara.';
      } else if (err.name === 'NotReadableError') {
        errorMessage = 'La cámara está siendo usada por otra aplicación.';
      } else if (err.message === 'getUserMedia not supported') {
        errorMessage = 'Tu navegador no soporta acceso a la cámara. Usa un navegador más reciente.';
      } else if (err.message === 'HTTPS required') {
        errorMessage = 'Se requiere HTTPS para acceder a la cámara. Contacta al administrador.';
      }
      
      setError(errorMessage);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
  };

  const capturePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0);

      canvas.toBlob((blob) => {
        const file = new File([blob], `photo_${currentSection}_${Date.now()}.jpg`, {
          type: 'image/jpeg'
        });
        onCapture(file);
        onClose();
      }, 'image/jpeg', 0.8);
    }
  };

  const handleClose = () => {
    stopCamera();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.cameraDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            Tomar Foto - {currentSection}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className={classes.cameraContainer}>
          {error ? (
            <Box textAlign="center" py={4}>
              <Typography color="error" variant="body1" gutterBottom>
                {error}
              </Typography>
              {error.includes('Permisos') && (
                <Box mt={2}>
                  <Typography variant="body2" color="textSecondary">
                    Para habilitar la cámara:
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    1. Toca el ícono de candado en la barra de direcciones
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    2. Selecciona "Permitir" para la cámara
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    3. Recarga la página
                  </Typography>
                </Box>
              )}
              <Box mt={3}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={startCamera}
                  style={{ marginRight: 8 }}
                >
                  Reintentar
                </Button>
                <Button 
                  variant="outlined" 
                  onClick={handleClose}
                >
                  Usar Subir Archivo
                </Button>
              </Box>
            </Box>
          ) : (
            <>
              <video
                ref={videoRef}
                autoPlay
                playsInline
                className={classes.cameraPreview}
                style={{ display: stream ? 'block' : 'none' }}
              />
              <canvas ref={canvasRef} style={{ display: 'none' }} />
              {stream && (
                <div className={classes.cameraControls}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={capturePhoto}
                    startIcon={<CameraAltIcon />}
                    size="large"
                  >
                    Capturar
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

const ProgressDialog = ({ open, message, uploading }) => {
  const classes = useStyles();
  
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent style={{ textAlign: 'center', padding: '40px 20px' }}>
        <CircularProgress 
          size={60} 
          style={{ marginBottom: 20, color: '#1976d2' }} 
        />
        <Typography variant="h6" style={{ marginBottom: 10, fontWeight: 600 }}>
          {message}
        </Typography>
        {uploading && (
          <Typography variant="body2" color="textSecondary">
            Por favor espera mientras se procesan las imágenes...
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

const PhotoSection = ({ title, photos, onAddPhoto, onRemovePhoto, sectionKey }) => {
  const classes = useStyles();
  const [cameraOpen, setCameraOpen] = useState(false);
  const [addMenuAnchor, setAddMenuAnchor] = useState(null);

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      onAddPhoto(sectionKey, files[0]);
    }
  };

  const handleCameraCapture = (file) => {
    onAddPhoto(sectionKey, file);
  };

  const handleAddMoreClick = (event) => {
    setAddMenuAnchor(event.currentTarget);
  };

  const handleAddMoreClose = () => {
    setAddMenuAnchor(null);
  };

  const handleFileUpload = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.multiple = false;
    fileInput.onchange = (e) => {
      if (e.target.files && e.target.files[0]) {
        handleFileChange([e.target.files[0]]);
      }
    };
    fileInput.click();
    handleAddMoreClose();
  };

  const handleCameraCaptureFromMenu = () => {
    setCameraOpen(true);
    handleAddMoreClose();
  };

  return (
    <div className={classes.photoSection}>
      <div className={classes.sectionHeader}>
        <Typography variant="h6" color="primary">
          {title}
        </Typography>
      </div>
      
      {(photos.length > 0 || true) && (
        <div className={classes.photoGrid}>
          {photos.map((photo, index) => (
            <Card key={index} className={classes.photoCard}>
              <img
                src={URL.createObjectURL(photo)}
                alt={`${title} ${index + 1}`}
              />
              <IconButton
                className={classes.deleteButton}
                size="small"
                onClick={() => onRemovePhoto(sectionKey, index)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Card>
          ))}
          
          {/* Add More Button */}
          <div 
            className={classes.addMoreButton}
            onClick={handleAddMoreClick}
          >
            <AddIcon className={classes.addMoreIcon} />
            <Typography className={classes.addMoreText}>
              Agregar Foto
            </Typography>
          </div>
        </div>
      )}

      <CameraDialog
        open={cameraOpen}
        onClose={() => setCameraOpen(false)}
        onCapture={handleCameraCapture}
        currentSection={title}
      />

      <Menu
        anchorEl={addMenuAnchor}
        open={Boolean(addMenuAnchor)}
        onClose={handleAddMoreClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleFileUpload}>
          <CloudUploadIcon style={{ marginRight: 8 }} />
          Subir Archivo
        </MenuItem>
        <MenuItem onClick={handleCameraCaptureFromMenu}>
          <CameraAltIcon style={{ marginRight: 8 }} />
          Tomar Foto
        </MenuItem>
      </Menu>
    </div>
  );
};

const SignaturePad = ({ onChange }) => {
  const classes = useStyles();
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    
    // Prevent scrolling on touch devices
    const preventScroll = (e) => {
      e.preventDefault();
    };
    
    // Add passive: false to ensure preventDefault works
    canvas.addEventListener('touchstart', preventScroll, { passive: false });
    canvas.addEventListener('touchmove', preventScroll, { passive: false });
    canvas.addEventListener('touchend', preventScroll, { passive: false });
    
    return () => {
      canvas.removeEventListener('touchstart', preventScroll);
      canvas.removeEventListener('touchmove', preventScroll);
      canvas.removeEventListener('touchend', preventScroll);
    };
  }, []);

  const getCoords = e => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    
    // Calculate scaling factors between display size and actual canvas resolution
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    
    let clientX, clientY;
    
    if (e.touches && e.touches.length > 0) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY
    };
  };

  const startDrawing = e => {
    e.preventDefault();
    e.stopPropagation();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getCoords(e);
    
    ctx.beginPath();
    ctx.moveTo(x, y);
    setDrawing(true);
    
    // Draw a small dot for single taps
    ctx.arc(x, y, 1, 0, 2 * Math.PI);
    ctx.fill();
  };

  const draw = e => {
    if (!drawing) return;
    e.preventDefault();
    e.stopPropagation();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getCoords(e);
    
    // Create a smooth line by connecting to the previous point
    ctx.beginPath();
    ctx.moveTo(ctx.lastX || x, ctx.lastY || y);
    ctx.lineTo(x, y);
    ctx.stroke();
    
    // Store the current position for the next line segment
    ctx.lastX = x;
    ctx.lastY = y;
  };

  const stopDrawing = e => {
    if (!drawing) return;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setDrawing(false);
    
    // Clean up the last position
    const ctx = canvasRef.current.getContext("2d");
    ctx.lastX = null;
    ctx.lastY = null;
    
    const canvas = canvasRef.current;
    const base64 = canvas.toDataURL("image/png");
    onChange(base64);
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    onChange(null);
  };

  return (
    <Box>
      <canvas
        ref={canvasRef}
        width={600}
        height={200}
        className={classes.canvas}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseLeave={stopDrawing}
        onTouchStart={startDrawing}
        onTouchMove={draw}
        onTouchEnd={stopDrawing}
      />
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="outlined" color="secondary" onClick={clear}>
          Borrar Firma
        </Button>
      </Box>
    </Box>
  );
};

const WorkOrderChecklist = ({ work_order_id }) => {
  const classes = useStyles();
  const [workOrderChecklist, setWorkOrderChecklist] = useState({});
  const [photosBySection, setPhotosBySection] = useState({
    front: [],
    back: [],
    left: [],
    right: [],
    roof: [],
    tires: [],
    others: []
  });
  const [signature, setSignature] = useState(null);
  const [damages, setDamages] = useState([]);
  const [editingDamage, setEditingDamage] = useState(null);
  const [comments, setComments] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const [saving, setSaving] = useState(false);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [bookingInfo, setBookingInfo] = useState({
    firstname: "",
    lastname: "",
    document_number: ""
  });
  const [loadingBooking, setLoadingBooking] = useState(false);
  const [vehicleType, setVehicleType] = useState(null);

  const types = [
    { id: 0, name: "Checklist de entrega" },
    { id: 1, name: "Checklist de devolución" },
    { id: 2, name: "Checklist de mantenimiento" }
  ];
  const state_types = ["Excelente", "Muy Bueno", "Bueno", "Regular", "Malo"];

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order_checklists().get(work_order_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => setWorkOrderChecklist(res.data))
      .catch(() => {});
    
    // Fetch booking information
    fetchBookingInfo();
  }, [work_order_id]);

  const handleInputChange = (field, value) => {
    setWorkOrderChecklist(prev => ({ ...prev, [field]: value }));
  };

  const handleAddPhoto = (section, photo) => {
    setPhotosBySection(prev => ({
      ...prev,
      [section]: [...prev[section], photo]
    }));
  };

  const handleRemovePhoto = (section, index) => {
    setPhotosBySection(prev => ({
      ...prev,
      [section]: prev[section].filter((_, i) => i !== index)
    }));
  };

  const handleAddDamage = (damage) => {
    setDamages(prev => [...prev, damage]);
    setEditingDamage(damage);
  };

  const handleRemoveDamage = (damageId) => {
    setDamages(prev => prev.filter(damage => damage.id !== damageId));
  };

  const handleEditDamage = (damage) => {
    setEditingDamage(damage);
  };

  const handleSaveDamage = (updatedDamage) => {
    setDamages(prev => prev.map(damage => 
      damage.id === updatedDamage.id ? updatedDamage : damage
    ));
    setEditingDamage(null);
  };

  const uploadPhotosIndividually = async (workOrderId) => {
    setUploadingPhotos(true);
    setProgressMessage("Adjuntando imágenes...");
    
    const token = localStorage.getItem("userToken");
    let uploadedCount = 0;
    let totalPhotos = 0;
    
    // Count total photos
    Object.values(photosBySection).forEach(photos => {
      totalPhotos += photos.length;
    });
    
    try {
      for (const [section, photos] of Object.entries(photosBySection)) {
        for (let i = 0; i < photos.length; i++) {
          const photo = photos[i];
          const formData = new FormData();
          formData.append('media', photo);
          formData.append('section', section);
          formData.append('description', `Foto ${i + 1} - ${section}`);
          
          await axios.post(api.work_orders().attach_media(workOrderId), formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`
            }
          });
          
          uploadedCount++;
          setProgressMessage(`Adjuntando imágenes... ${uploadedCount}/${totalPhotos}`);
        }
      }
      
      setUploadingPhotos(false);
      setProgressMessage("");
      return true;
    } catch (error) {
      console.error('Error uploading photos:', error);
      setUploadingPhotos(false);
      setProgressMessage("");
      return false;
    }
  };

  const fetchBookingInfo = async () => {
    if (!work_order_id) return;
    
    setLoadingBooking(true);
    const token = localStorage.getItem("userToken");
    
    try {
      // First, get the work order to get the booking_id
      const workOrderResponse = await axios.get(api.work_order().get(work_order_id), {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      const bookingId = (workOrderResponse.data && workOrderResponse.data.booking && workOrderResponse.data.booking.id);
      
      if (bookingId) {
        // Then, get the booking details
        const bookingResponse = await axios.get(api.bookings().get(bookingId), {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        const booking = bookingResponse.data;
        setBookingInfo({
          firstname: (booking && booking.subcontact && booking.subcontact.firstname) || "",
          lastname: (booking && booking.subcontact && booking.subcontact.lastname) || "",
          document_number: (booking && booking.contact_document_number) || ""
        });
        
        // Extract vehicle type information
        if (booking && booking.vehicle && booking.vehicle.vehicle_type_code) {
          setVehicleType(booking.vehicle.vehicle_type_code);
        } else{
          setVehicleType("5PI");
        }
      }
    } catch (error) {
      console.error('Error fetching booking info:', error);
      setSnackbar({
        open: true,
        message: "Error al cargar información del contacto",
        severity: "warning"
      });
    } finally {
      setLoadingBooking(false);
    }
  };

  const handleSubmit = async () => {
    setSaving(true);
    setProgressMessage("Guardando checklist...");
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.set("work_order_checklist[work_order_id]", work_order_id);

    Object.keys(workOrderChecklist).forEach(key =>
      formData.set(
        `work_order_checklist[${key}]`,
        workOrderChecklist[key] || ""
      )
    );
    
    // Add damages data
    if (damages.length > 0) {
      formData.set("damages", JSON.stringify(damages));
    }
    
    // Add comments
    if (comments.trim()) {
      formData.set("work_order_checklist[comments]", comments);
    }
    
    if (signature) formData.set("signature", signature);

    try {
      const url = workOrderChecklist.id
        ? api.work_order_checklists().patch(workOrderChecklist.id)
        : api.work_order_checklists().post();

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      });

      // Get the work order ID from response or use existing one
      const workOrderId = (response.data && response.data.work_order_id) || work_order_id;
      
      // Upload photos individually if there are any
      const hasPhotos = Object.values(photosBySection).some(photos => photos.length > 0);
      if (hasPhotos) {
        const photosUploaded = await uploadPhotosIndividually(workOrderId);
        if (!photosUploaded) {
          setSnackbar({
            open: true,
            message: "Checklist guardado pero hubo problemas subiendo las fotos",
            severity: "warning"
          });
          return;
        }
      }

      setSnackbar({
        open: true,
        message: "Checklist guardado correctamente",
        severity: "success"
      });
    } catch (error) {
      console.error('Error saving checklist:', error);
      setSnackbar({
        open: true,
        message: "Error al guardar el checklist",
        severity: "error"
      });
    } finally {
      setSaving(false);
      setProgressMessage("");
    }
  };

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="sticky">
        <Toolbar>
          <DirectionsCarIcon style={{ marginRight: 8 }} />
          <Typography variant="h6" className={classes.title}>
            Checklist de Vehículo
          </Typography>
        </Toolbar>
      </AppBar>

      <Container className={classes.container}>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <DescriptionIcon /> Información Básica
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                label="Tipo de checklist"
                fullWidth
                value={workOrderChecklist.type || ""}
                onChange={e => handleInputChange("type", e.target.value)}
                variant="outlined"
              >
                {types.map(t => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                type="number"
                label="Kilometraje"
                fullWidth
                value={workOrderChecklist.km || ""}
                onChange={e => handleInputChange("km", e.target.value)}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <DescriptionIcon /> Estado del Vehículo
          </Typography>
          <Grid container spacing={2}>
            {[
              { field: "exterior_status", label: "Estado exterior" },
              { field: "interior_status", label: "Estado interior" },
              { field: "tier_status", label: "Estado cubiertas" }
            ].map(f => (
              <Grid item xs={12} md={4} key={f.field}>
                <TextField
                  select
                  fullWidth
                  label={f.label}
                  value={workOrderChecklist[f.field] || ""}
                  onChange={e => handleInputChange(f.field, e.target.value)}
                  variant="outlined"
                >
                  {state_types.map(opt => (
                    <MenuItem key={opt} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            ))}
          </Grid>
        </Paper>

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <PhotoCameraIcon /> Fotos del Vehículo
          </Typography>
          
          <PhotoSection
            title="Frente"
            photos={photosBySection.front}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="front"
          />
          
          <PhotoSection
            title="Trasera"
            photos={photosBySection.back}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="back"
          />
          
          <PhotoSection
            title="Lado Izquierdo"
            photos={photosBySection.left}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="left"
          />
          
          <PhotoSection
            title="Lado Derecho"
            photos={photosBySection.right}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="right"
          />
          
          <PhotoSection
            title="Techo"
            photos={photosBySection.roof}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="roof"
          />
          
          <PhotoSection
            title="Cubiertas"
            photos={photosBySection.tires}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="tires"
          />
          
          <PhotoSection
            title="Otros"
            photos={photosBySection.others}
            onAddPhoto={handleAddPhoto}
            onRemovePhoto={handleRemovePhoto}
            sectionKey="others"
          />
        </Paper>

        {vehicleType && <Paper className={classes.paper}>
          <CarDamageMarker
            damages={damages}
            onAddDamage={handleAddDamage}
            onRemoveDamage={handleRemoveDamage}
            onEditDamage={handleEditDamage}
            vehicleType={vehicleType}
          />
        </Paper>} 

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <DescriptionIcon /> Comentarios Adicionales
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Agrega cualquier comentario adicional sobre el estado del vehículo, observaciones especiales, o notas importantes..."
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            style={{ marginTop: 8 }}
          />
        </Paper>

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <PersonIcon /> Información del Contacto
          </Typography>
          
          {loadingBooking ? (
            <Box display="flex" justifyContent="center" alignItems="center" py={3}>
              <CircularProgress size={24} style={{ marginRight: 8 }} />
              <Typography variant="body2" color="textSecondary">
                Cargando información del contacto...
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Nombre"
                  value={bookingInfo.firstname}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Apellido"
                  value={bookingInfo.lastname}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Documento"
                  value={bookingInfo.document_number}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          )}
        </Paper>

        <Paper className={classes.paper}>
          <Typography className={classes.sectionTitle}>
            <DescriptionIcon /> Firma del Cliente
          </Typography>
          <div className={classes.signatureContainer}>
            <Typography color="textSecondary" variant="body2" gutterBottom>
              Firma aquí debajo:
            </Typography>
            <SignaturePad onChange={setSignature} />
          </div>
        </Paper>
      </Container>

      <div className={classes.actionBar}>
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" style={{ marginRight: 12 }}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={saving}
              startIcon={
                saving ? <CircularProgress size={20} color="inherit" /> : null
              }
            >
              {saving ? "Guardando..." : "Guardar Checklist"}
            </Button>
          </Box>
        </Container>
      </div>

      <DamageEditDialog
        open={!!editingDamage}
        damage={editingDamage}
        onClose={() => setEditingDamage(null)}
        onSave={handleSaveDamage}
        damageTypes={[
          { value: "scratch", label: "Rayón" },
          { value: "dent", label: "Abolladura" },
          { value: "crack", label: "Grieta" },
          { value: "chip", label: "Chip" },
          { value: "rust", label: "Óxido" },
          { value: "other", label: "Otro" }
        ]}
        severityTypes={[
          { value: "minor", label: "Menor" },
          { value: "moderate", label: "Moderado" },
          { value: "major", label: "Mayor" }
        ]}
      />

      <ProgressDialog 
        open={saving || uploadingPhotos}
        message={progressMessage}
        uploading={uploadingPhotos}
      />
    </div>
  );
};

export default WorkOrderChecklist;
